import { render, staticRenderFns } from "./consultants-icon.vue?vue&type=template&id=1262d413"
import script from "./consultants-icon.vue?vue&type=script&lang=js"
export * from "./consultants-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports